(async () => {
  if (typeof window !== 'undefined' && !window.fetch) {
    await import('whatwg-fetch');
  }
})();
